import './Terms.css';

export function Terms() {
  return (
    <div className="terms">
      <h1>Termos de Uso</h1>
      <div className="content">
        <p>Nossos termos de uso...</p>
      </div>
    </div>
  );
} 